module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-hyundai.2bf12d2a.png";